import React from 'react';
import { ProjectFilter, ProjectStatus } from 'nekst-api';
import { useFilterContext } from 'ui-builder';
import styles from './QuickFilter.module.scss';
import { useProjectStatisticContextRequired } from 'features/tasks-forms';

function TotalNumber(props: { status: ProjectStatus }) {
  const statistic = useProjectStatisticContextRequired().statistic;

  if (statistic) {
    let count;

    switch (props.status) {
      case ProjectStatus.ACTIVE:
        count = statistic.totalByStatus.active;
        break;
      case ProjectStatus.CLOSED:
        count = statistic.totalByStatus.closed;
        break;
      case ProjectStatus.ARCHIVED:
        count = statistic.totalByStatus.archived;
        break;
      default:
        count = undefined;
    }

    if (count !== undefined) {
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <>{` (${count})`}</>;
    } else {
      return null;
    }
  } else {
    return null;
  }
}

function QuickFilter(props: { status: ProjectStatus }) {
  const filterContext = useFilterContext<ProjectFilter>();

  const classes = [
    styles.filter,
  ];

  if (filterContext.filterValue?.status === props.status) {
    classes.push(styles.active);
  }

  return (
    // eslint-disable-next-line max-len
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <span
      className={classes.join(' ')}
      onClick={() => {
        const newFilterValue = {
          ...filterContext.filterValue!,
          status: props.status,
        };
        filterContext.setFilterValue(newFilterValue);
      }}
    >
      {props.status}
      <TotalNumber status={props.status} />
    </span>
  );
}

export default function QuickFilters() {
  return (
    <div data-key="projects-status-filter" style={{ display: 'inline-block' }}>
      <QuickFilter status={ProjectStatus.ACTIVE} />
      <QuickFilter status={ProjectStatus.CLOSED} />
      <QuickFilter status={ProjectStatus.ARCHIVED} />
    </div>
  );
}
